import { render } from "./TabManageAddress.vue?vue&type=template&id=b935bdb6"
import script from "./TabManageAddress.vue?vue&type=script&lang=js"
export * from "./TabManageAddress.vue?vue&type=script&lang=js"

import "./TabManageAddress.vue?vue&type=style&index=0&id=b935bdb6&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__